import { EstadaRadioGroup } from "../../../src/components/EstadaRadioGroup";
import { itx } from "../../../src/translationItx/itx";
export type C1_RoombookViewMode = "functions" | "groups";

export function C1_RoombookViewModeSelect({
  value,
  onChange,
}: {
  value: C1_RoombookViewMode;
  onChange: (value: C1_RoombookViewMode) => void;
}) {
  return (
    <EstadaRadioGroup className="C1_roombookViewMode" label={itx("c1.ui.Raumbuch_Darstellung", "Raumbuch-Darstellung")}
      value={value} onChange={onChange} options={[
        { value: "functions", label: itx("c1.ui.Funktionen", "Funktionen") },
        { value: "groups", label: itx("components.plural.group", "Gruppen") },
      ]} />
  );
}
